module.exports = __webpack_public_path__ + "static/media/17.a27fcf11.jpg";